<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">资产负债表</span>
			<span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
		</div>
		<div class="margin-right-left margin-top">
			<account-date-choose v-model="accountDate"/>
      <Button color="primary" @click="submit" class="margin-left">数据汇总</Button>
      <Button color="primary" @click="exportToExcel" :loading="loading" >导出 Excel</Button>
      <Button :loading="loading" :disabled="!dataList.length" color="red" @click="batchDelete">删除当期数据</Button>

		</div>
    <div class="h-panel-body">
      <Table :datas="dataList" :border="true" stripe>
        <TableItem title="序号" :width="50">
          <template v-slot="{ index, data }">
            {{  index + 1 }}
          </template>
        </TableItem>
        <TableItem title="账套名称" prop="companyName" ></TableItem>
        <TableItem title="日期" prop="heusanDate" ></TableItem>
        <TableItem title="科目代码" prop="code" ></TableItem>
        <TableItem title="科目名称" prop="name" ></TableItem>
        <TableItem title="期初借方" prop="qichujie" ></TableItem>
        <TableItem title="期初贷方" prop="qichudai" ></TableItem>
        <TableItem title="期末借方" prop="qimojie" ></TableItem>
        <TableItem title="期末贷方" prop="qimodai"></TableItem>
      </Table>
    </div>
	</app-content>
</template>

<script>
 import moment from "moment";
 import {mapState} from "vuex";
 import * as XLSX from "xlsx";

 /**
	 * 保存新资产负债表
	 */
	export default {
		name: "ZiChanFuZhai",
		data() {
			return {
        dataList: [],
        dataList2: [],
        dataList3: [],
				accountDate: null,
				showNumPrice: false,
				loading: false,
        quniandate: null,
        // 一级科目代码模板（根据实际需求补充完整）
        dataList1:[
          {'code':'1001', 'name':'库存现金','nianchushu':null,'qichushu':null,'qimoshu':null}, //库存现金
          {'code':'1002', 'name':'银行存款','nianchushu':null,'qichushu':null,'qimoshu':null}, //银行存款
          {'code':'1003', 'name':'应收账款','nianchushu':null,'qichushu':null,'qimoshu':null}, //应收账款
          {'code':'1004', 'name':'其他应收款','nianchushu':null,'qichushu':null,'qimoshu':null}, //其他应收款
          {'code':'100401', 'name':'押金','nianchushu':null,'qichushu':null,'qimoshu':null}, //押金
          {'code':'100402', 'name':'借款','nianchushu':null,'qichushu':null,'qimoshu':null}, //借款
          {'code':'100403', 'name':'装修款','nianchushu':null,'qichushu':null,'qimoshu':null},
          {'code':'100404', 'name':'员工社保费','nianchushu':null,'qichushu':null,'qimoshu':null},
          {'code':'1005', 'name':'库存商品','nianchushu':null,'qichushu':null,'qimoshu':null}, //库存商品
          {'code':'1006', 'name':'低值易耗品','nianchushu':null,'qichushu':null,'qimoshu':null}, //低值易耗品
          {'code':'1007', 'name':'原材料','nianchushu':null,'qichushu':null,'qimoshu':null}, //原材料
          {'code':'1008', 'name':'固定资产','nianchushu':null,'qichushu':null,'qimoshu':null}, //固定资产
          {'code':'1009', 'name':'累计折旧','nianchushu':null,'qichushu':null,'qimoshu':null}, //累计折旧
          {'code':'1010', 'name':'待摊费用','nianchushu':null,'qichushu':null,'qimoshu':null}, //待摊费用
          {'code':'1011', 'name':'投资损失','nianchushu':null,'qichushu':null,'qimoshu':null}, //投资损失
          {'code':'2001', 'name':'应付账款','nianchushu':null,'qichushu':null,'qimoshu':null}, //应付账款
          {'code':'2002', 'name':'应付职工薪酬','nianchushu':null,'qichushu':null,'qimoshu':null}, //应付职工薪酬
          {'code':'2003', 'name':'其他应付款','nianchushu':null,'qichushu':null,'qimoshu':null}, //其他应付款
          {'code':'2004', 'name':'预提费用','nianchushu':null,'qichushu':null,'qimoshu':null}, //预提费用
          {'code':'2005', 'name':'递延收益','nianchushu':null,'qichushu':null,'qimoshu':null}, //递延收益
          {'code':'2006', 'name':'顾客定金','nianchushu':null,'qichushu':null,'qimoshu':null}, //顾客定金
          {'code':'2007', 'name':'顾客欠货','nianchushu':null,'qichushu':null,'qimoshu':null}, //顾客欠货
        ],
        codeList: [
          '1001',
          '1002',
          '1003',
          '1004',
          '100401',
          '100402',
          '100403',
          '100404',
          '1005',
          '1006',
          '1007',
          '1008',
          '1009',
          '1010',
          '1011',
          '2001',
          '2002',
          '2003',
          '2004',
          '2005',
          '2006',
          '2007',
        ]
			}
		},
   computed: {
     ...mapState(['currentAccountSets'])
   },
		watch: {
      accountDate(newVal) {
        if (newVal) {
          // 创建日期对象
          const date = new Date(newVal);

          // 检查当前日期是否已经是1号
          if (date.getDate() !== 1) {
            // 设置为1号
            date.setDate(1);
            // 格式化为 YYYY-MM-DD
            const firstDay = date.toISOString().slice(0, 10);

            // 更新 accountDate 为每月1号
            this.$nextTick(() => {
              if (this.accountDate !== firstDay) {
                this.accountDate = firstDay;
              }
            });
          } else {
            // 如果已经是 1 号，直接加载数据
            this.loadList();

          }
        }

      },
		},
		methods: {
      batchDelete() {
        // 检查是否有选中项
        if (this.dataList.length === 0) {
          this.$Message.error('请选择要删除的数据！');
          return;
        }

        // 显示确认对话框，提示删除数量
        this.$Confirm(`确认要删除本期的数据吗？`, '批量删除').then(() => {
          this.loading = true;
          // 提取所有选中项的 ID
          const ids = this.dataList.map(item => item.id);

          this.$api.bumenhuizong.zichanfuzhai.batchDelete(ids).then(() => {
            this.$Message.success(`成功删除 ${this.dataList.length} 条数据！`);
            this.dataList = [];
            this.loadList();
          }).catch(() => {
            this.$Message.error('批量删除失败，请重试！');
          }).finally(() => {
            this.loading = false;
          });
        }).catch((error) => {
          // 处理用户取消操作，避免HeyUI的cancel错误
          if (error !== 'cancel') {
            const isCancelError = error === 'cancel' || (error && error.message === 'cancel')
            if (!isCancelError) {
              console.error('确认对话框错误:', error);
            }
          }
          // 用户点击取消按钮，不做任何处理
          this.loading = false;
        })
      },


      /**
       * 提交数据
       */
      async submit() {
        if (this.dataList.length) {
          this.$Message.error('本月数据已存在，请勿重复提交！');
        } else {
          this.dataList2 = [];
          this.loading = true;
          try {
            // 等待数据加载完成
            await this.loadListaccount();
            // 构建资产负债表数据
            this.dataList3.forEach(item => {
              const zichanItem = {};
              zichanItem.companyName = this.currentAccountSets.companyName;
              zichanItem.accountSetsId = this.currentAccountSets.id;
              zichanItem.heusanDate = this.accountDate;
              zichanItem.code = item.code;
              zichanItem.name = item.name;
              zichanItem.qichujie= item.beginningDebitBalance;
              zichanItem.qichudai = item.beginningCreditBalance;
              zichanItem.qimojie = item.endingDebitBalance;
              zichanItem.qimodai = item.endingCreditBalance;
              this.dataList2.push(zichanItem);
            });


            // 保存资产负债表数据（批量保存）
            await this.$api.bumenhuizong.zichanfuzhai.batchUpdate(this.dataList2);

            this.loadList();
            this.$Message.success('数据保存成功！');
            this.dataList2 = [];
          } catch (error) {
            // 如果错误是 true，说明实际保存成功了，只是 Ajax 封装有问题
            if (error === true) {
              this.loadList();
              this.$Message.success('数据保存成功！');
              this.dataList2 = [];
            } else {
              console.error('保存失败:', error);
              this.$Message.error('数据保存失败，请重试！');
            }
          } finally {
            this.loading = false;
          }
        }
      },





      /**
       * 导出 Excel
       */
      exportToExcel() {
        if (this.dataList.length === 0) {
          this.$Message.warning('没有可导出的数据');
          return;
        }

        this.loading = true;

        try {
          // 准备导出数据
          const exportData = this.dataList.map((item, index) => ({
            '序号': index + 1,
            '账套名称': item.companyName || '',
            '日期': item.heusanDate || '',
            '科目代码': item.code || '',
            '科目名称': item.name || '',
            '期初借方': item.qichujie !== null ? item.qichujie : '',
            '期初贷方': item.qichudai !== null ? item.qichudai : '',
            '期末借方': item.qimojie !== null ? item.qimojie : '',
            '期末贷方': item.qimodai !== null ? item.qimodai : ''
          }));

          // 创建工作表
          const worksheet = XLSX.utils.json_to_sheet(exportData);

          // 设置列宽
          const colWidths = [
            { wch: 8 },   // 序号
            { wch: 20 },  // 账套名称
            { wch: 12 },  // 日期
            { wch: 15 },  // 科目代码
            { wch: 20 },  // 科目名称
            { wch: 15 },  // 期初借方
            { wch: 15 },  // 期初贷方
            { wch: 15 },  // 期末借方
            { wch: 15 }   // 期末贷方
          ];
          worksheet['!cols'] = colWidths;

          // 创建工作簿
          const workbook = XLSX.utils.book_new();

          // 获取当前日期作为文件名的一部分
          const fileNameDate = this.accountDate ? moment(this.accountDate).format('YYYY-MM') : moment().format('YYYY-MM');
          XLSX.utils.book_append_sheet(workbook, worksheet, `汇总资产负债表${fileNameDate}`);

          // 导出文件
          const fileName = `汇总资产负债表_${fileNameDate}.xlsx`;
          XLSX.writeFile(workbook, fileName);

          // 显示成功提示
          this.$Message.success(`数据导出成功，文件名：${fileName}`);
        } catch (error) {
          console.error('导出失败:', error);
          this.$Message.error('导出失败，请重试');
        } finally {
          this.loading = false;
        }
      },



      loadListaccount() {
        this.loading = true;
        return  this.$api.accountbook.loadSubjectBalance2({
          accountDate: moment(this.accountDate).endOf('month').format('YYYY-MM-DD'),
          showNumPrice: this.showNumPrice
        }).then(({data}) => {
          this.dataList3 = data.filter(item => this.codeList.includes(item.code));
          // 查找 name 为"合计"的记录
          const totalRecord = data.find(item => item.name === '合计');
          // 如果找到合计记录，添加到过滤后的数据末尾
          if (totalRecord) {
            this.dataList3 = [...this.dataList3, totalRecord];
          }
          this.loading = false;
        });
      },

      loadList() {
        if (!this.accountDate) {
          console.warn('accountDate 为空，不加载数据');
          return;
        }
        this.$api.bumenhuizong.zichanfuzhai.list(this.accountDate)
            .then(({data}) => {
              this.dataList = data;
            })
            .catch((error) => {
              console.error('加载资产负债表失败:', error);
              // 不显示错误提示，因为可能是正常情况（没有数据）
            });

      },
		},
   mounted() {
     // this.loadList()
   }
	}
</script>

<style scoped lang="less">
	.h-panel-bar {
		display: flex; /* 使用 Flexbox 布局 */
		justify-content: space-between; /* 让子元素两端对齐 */
		align-items: center; /* 垂直居中对齐 */
	}
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
